<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('all_notification')" icon="bell"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button" v-if="showAllBtn == true">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        data-toggle="modal"
                        @click="viewAll">
                        {{ $t("view_all") }}
                    </button>

                </div>
            </div>
        </div>

        <app-table :id="tableId" :options="options" @action="triggerActions"/>
    <notification-view-modal
      v-if="isNotificationViewModalActive"
      :info="task_info"
      :type="type"
      @close-modal="closeNotificationViewModal"
    />
    </div>
</template>

<script>
    import * as actions from '../../../Config/ApiUrl'
    import AppLibrary from "../../../Helpers/AppLibrary";
    import {formatDateToLocal, onlyTime, optional} from "../../../Helpers/Helpers";
    import {axiosPost} from "../../../Helpers/AxiosHelper";
    export default {
        name: "AllNotification",
        extends: AppLibrary,
        data() {
            return {
                showAllBtn: false,
                task_info: {},
                type: '',
                isNotificationViewModalActive: false,
                selectedUrl: '',
                tableId: 'all-notifications',
                rowData: {},
                options: {
                    name: 'All Notifications',
                    url: actions.NOTIFICATIONS,
                    showHeader: true,
                    columns: [
                        // {
                        //     title: this.$t('title'),
                        //     type: 'button',
                        //     key: 'data',
                        //     className: 'btn btn-sm btn-link',
                        //     actionType: 'read',
                        //     modifier: data => data.message.replace(/<[^>]*>/g, '')
                        // },
                        {
                            title: this.$t('title'),
                            type: 'custom-html',
                            key: 'data',
                            modifier: (data, rowData) => {
                                return `<a href="#" id="${rowData.id}" @click=${this.myFunction(rowData)}>${data.message.replace(/<[^>]*>/g, '')}</a>`;
                            }

                        },
                        {
                            title: this.$t('notification_from'),
                            type: 'object',
                            key: 'notifier',
                            uniqueKey: 'id',
                            modifier: function (notifier, rowData) {
                                return optional(notifier, 'full_name');
                            }
                        },
                        {
                            title: this.$t('date'),
                            type: 'object',
                            key: 'created_at',
                            uniqueKey: 'id',
                            modifier: function (created_at, rowData) {
                                return formatDateToLocal(created_at)
                            }
                        },
                        {
                            title: this.$t('time'),
                            type: 'object',
                            key: 'created_at',
                            uniqueKey: 'id',
                            modifier: function (created_at, rowData) {
                                return onlyTime(created_at)
                            }
                        },
                    ],
                    filters: [
                        {
                            "title": this.$t('created'),
                            "type": "range-picker",
                            "key": "date",
                            "option": ["today", "thisMonth", "last7Days", "thisYear"]
                        },
                        {
                            "title": this.$t('status'),
                            "type": "radio",
                            "key": "unread",
                            "option": [
                                {id: '', value: 'All'},
                                {id: '1', value: 'Un Read'},
                            ],
                            "header": {
                                "title": this.$t('Filter All & Unread Notifications.'),
                                // "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
                            },
                                
                        },
                        {
                            "title": this.$t("search_and_select"),
                            "type": "drop-down-filter",
                            "key": "search select",
                            "option": [],
                        },
                    ],
                    showFilter: true,
                    showSearch: false,
                    paginationType: "pagination",
                    responsive: true,
                    showCount: true,
                    rowLimit: 10,
                    showAction: false,
                    showClearFilter: true,
                    orderBy: 'desc',
                    actionType: "dropdown",
                    actions: [
                        {
                            title: this.$t('copy'),
                            icon: 'copy',
                            type: 'page',
                            url: `/`,
                            name: 'copy'
                        }
                    ],
                }
            }
        },
        created(){
            this.searchAndSelectFilterOptions();
        },
        mounted(){
            let urlParams = new URLSearchParams(window.location.search);
            if(urlParams.has('id') == true) {
                this.showAllBtn = true;
                let id = urlParams.get('id');
                console.log(id);
                this.options.url = actions.NOTIFICATIONS+'?id='+id;
            }
        },
        methods: {
            viewAll() {
               window.location = '/all-notifications';
            },
            triggerActions(row, action, active) {
                this.readNotification(row);
            },
            readNotification(notification) {
                axiosPost(`admin/user/notifications/mark-as-read/${notification.id}`).then(({data}) => {
                    if (data.data.url) {
                        window.location = data.data.url;
                    }
                });
            },
            myFunction(data){
                let doc = document.getElementById(data.id);
                if(doc){
                    doc.addEventListener('click', () => {
                        this.view(data);
                    }) 
                }
            },
            view(data) {
                // alert("App\Notifications\Core\User\UserNotification".replace(/\\/g, ''));    
                if(data.type.replace(/\\/g, '') == "App\Notifications\Core\User\UserNotification".replace(/\\/g, '')) {
                    this.readNotification(data);
                }
                else if(data.type.replace(/\\/g, '') == 'App\Notifications\Core\Role\RoleNotification'.replace(/\\/g, '')) {
                    this.readNotification(data);
                }
                else if(data.type.replace(/\\/g, '') == 'App\Notifications\Core\Task\TaskNotification'.replace(/\\/g, '')) {
                    axiosPost(`admin/user/notifications/mark-as-read/${data.id}`).then(({data}) => {
                        if (data) {
                            // alert('test1');
                            this.openModal(data, 'task');
                        }
                    });
                    
                }
                else if(data.type.replace(/\\/g, '') == 'AppNotificationsCoreDocumentDocumentNotification'.replace(/\\/g, '')) {
                    axiosPost(`admin/user/notifications/mark-as-read/${data.id}`).then(({data}) => {
                        if (data) {
                            // alert('test2');

                            this.openModal(data, 'documents');
                        }
                    });
                    
                }else{
                    alert('not found');
                }
            },
            openModal(data, type) {
                this.task_info = data;
                this.type = type;
                this.isNotificationViewModalActive = true;
            },
            closeNotificationViewModal() {
                $("#notification-view-modal").modal("hide");
                this.isNotificationViewModalActive = false;
            },
            searchAndSelectFilterOptions() {
                this.axiosGet(actions.NOTIFICATIONS_TYPE).then((response) => {
                    let name = this.options.filters.find(
                    (element) => element.title === this.$t("search_and_select")
                    );

                    name.option = response.data.map((name) => {
                    return {
                        id: name.name,
                        value: name.name,
                    };
                    });
                });
            },
        }
    }
</script>
